<template>
  <div>
    <HttpContentView :endpoint="utilities.path('modules/allowlist/applications/@', applicationId)" v-model:reload="reload">
      <template v-slot:content="{ data: application }">
        <div class="d-flex flex-column g-4">
          <div class="row align-items-center g-3">
            <div class="col-6" v-if="application.creator">
              <h4 class="mb-1">{{ translate('creator') }}</h4>
              <div class="text-left">
                <PlayerView :player="application.creator"/>
              </div>
            </div>
            <div class="col-6">
              <h4 class="mb-1">{{ translate('status') }}</h4>
              <span :class="{ 'text-danger': application.status.id === 3, 'text-success': application.status.id === 2, 'text-info': application.status.id === 1 }">{{ application.status.name }}</span>
            </div>
            <div class="col-6">
              <h4 class="mb-1">{{ translate('created_at') }}</h4>
              <span class="text-muted text-break">
              {{ utilities.formatDatetime(application.createdAt) }}
            </span>
            </div>
          </div>
          <div v-if="application.answers" class="list-group">
            <div class="list-group-item" v-for="answer in application.answers" :key="answer.id">
              <h4 class="text-white mb-2" v-if="answer.question">{{ answer.question.content }}</h4>
              <h4 class="text-white mb-2" v-else><del>{{ translate("deleted_question") }}</del></h4>
              <span class="small text-light" style="white-space: pre-line; word-break: break-word">{{ answer.content }}</span>
            </div>
          </div>
          <div v-if="application.replied" class="card">
            <div class="card-body">
              <h3>{{ translate("answer") }}</h3>
              <div v-if="application.reply" class="mt-1 small" style="white-space: pre-line; word-break: break-word">{{ application.reply }}</div>
              <div class="d-flex justify-content-between align-items-center g-3 mt-3 small">
                <UserView v-if="application.replier" :user="application.replier" class="d-inline-block"/>
                <span class="text-break">{{ utilities.formatDatetime(application.repliedAt) }}</span>
              </div>
            </div>
          </div>
          <div v-if="!application.replied && authorization.permission('modules.allowlist.applications.answer')">
            <HttpFormView :endpoint="utilities.path('modules/allowlist/applications/@/answer', application.id)" method="post" @success="emit('reply'); toasts.create({ color: 'success', content: translate('operation_successful') })">
              <template v-slot:form="{ content, errors, submit, loading }">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex flex-column g-4">
                      <SelectInputView v-model:value="content.status" :options="[{id: 2, title: translate('accepted')}, {id: 3, title: translate('denied')}]" :title="translate('status')" :errors="errors.status" required>
                        <template v-slot:option="{ option }">
                          {{ option.title }}
                        </template>
                      </SelectInputView>
                      <InputView type="textarea" :title="translate('content')" :errors="errors.content" v-model:value="content.content"/>
                      <SpinnerView :active="loading" color="primary"/>
                      <ButtonView type="normal" color="primary" class="w-100" @click="submit">
                        {{ translate("submit") }}
                      </ButtonView>
                    </div>
                  </div>
                </div>
              </template>
            </HttpFormView>
          </div>
          <TargetedModalHttpFormView v-if="authorization.permission('modules.allowlist.applications.delete')" :endpoint="utilities.path('modules/allowlist/applications/@', application.id)" method="delete" @success="emit('delete'); toasts.create({ color: 'success', content: translate('operation_successful') })">
            <template v-slot:target="{ show }">
              <div class="d-flex align-items-center g-4">
                <ButtonView type="soft" color="danger" class="w-100" @click="show">
                  <div class="d-flex align-items-center justify-content-center g-2">
                    <i class="fas fa-trash"></i>
                    <span>{{ translate("delete") }}</span>
                  </div>
                </ButtonView>
              </div>
            </template>
            <template v-slot:form="{ submit, loading, hide }">
              <SpinnerView :active="loading" color="danger"/>
              <div class="d-flex align-items-center g-4">
                <ButtonView type="normal" color="danger" class="w-100" @click="submit">
                  {{ translate("delete") }}
                </ButtonView>
                <ButtonView type="normal" color="secondary" class="w-100" @click="hide">
                  {{ translate("cancel") }}
                </ButtonView>
              </div>
            </template>
          </TargetedModalHttpFormView>
        </div>
      </template>
    </HttpContentView>
  </div>
</template>

<script setup>
import {ButtonView, HttpFormView, InputView, TargetedModalHttpFormView, SelectInputView, SpinnerView, utilities, HttpContentView} from "@/niftybit";
import PlayerView from "@/components/other/PlayerView.vue";
import {ref} from "vue";
import authorization from "@/authorization";
import {toasts} from "@/niftybit";
import UserView from "@/components/other/UserView.vue";

defineProps({
  applicationId: String
});

const emit = defineEmits(["reply", "delete"]);

const reload = ref(false);

</script>
